import { useAdSidebar } from "./hooks/useAdSidebar";
import { AdSideBarItem } from "../AdSideBarItem";
import "./AdSidebar.scss";

export const AdSideBar = () => {
  const { adCreators, isLoading } = useAdSidebar();

  if (isLoading) {
    return null;
  }

  return (
    <div className="adSideBar">
      <h3 className="adSideBarTitle">Onlyfans creators you might enjoy:</h3>
      <div className="adList">
        {adCreators.map((adCreator) =>
          <AdSideBarItem
            key={adCreator.extra.id}
            name={adCreator.extra.name}
            link={adCreator.link}
            image={adCreator.extra.imgUrl}
          />
        )}
      </div>
    </div>
  );
};
